module.exports = __webpack_public_path__ + "img/mehmet-kirci-start2.277e2948.png";